export class RoleReqModel {
	public id: string;
	public name: string;
	public description: string;
	public menus: string[];
	public access: string[];

	public clone(source: any): RoleReqModel {
		if (source.id) {
			this.id = source.id;
		}
		if (source.name) {
			this.name = source.name;
		}
		if (source.description) {
			this.description = source.description;
		}
		if (source.menus) {
			this.menus = source.menus;
		}
		if (source.access) {
			this.access = source.access;
		}

		return this;
	}

	public convert(): any {
		return {
			id: this.id,
			name: this.name,
			description: this.description,
			menus: this.menus,
			access: this.access,
		};
	}
}

export class RoleReqTakeoutModel {
	public payloads: any[];

	public clone(source: any[]): RoleReqTakeoutModel {
		if (source && source.length > 0) {
			this.payloads = source;
		}

		return this;
	}

	public convert(): any {
		return this.payloads;
	}
}

